(function($) {

	'use strict';

	function init(){
        toggleNav()
        toggleSubNav()
        toggleSearchBar()
	};

    function toggleNav(){

        $('#toggleNav').click(function(){

            $(this).toggleClass('active')
            $('#mainNav').toggleClass('active')
			$('body').toggleClass('mobileMenuActive')

        })

    }

    function toggleSubNav(){

        $('.menuItem__title').click(function(){

            $(this).parent().toggleClass('active')
            $('#mainNav').toggleClass('subNavActive')

        })

    }

    function toggleSearchBar(){

        $('#toggleSearch').click(function(){

            $('.mainHeader__search').toggleClass('active')
            setTimeout(function(){ $('.mainHeader__search input').focus() }, 350);

        })

    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
